import {
    BaseStructuredDataProps,
    prepareStructuredPageData,
} from "@hardware/Utilities/schemaOrg/prepareStructuredPageDataHelpers";

interface HomePageStructuredDataProps extends BaseStructuredDataProps {
    pageTitle?: string;
}

const prepareHomePageStructuredPageData = ({ pageTitle = "Home", website, location }: HomePageStructuredDataProps) => {
    return prepareStructuredPageData({
        pageTitle,
        pageType: "WebPage",
        breadcrumbLinks: undefined, // Homepage typically doesn't have breadcrumbs
        additionalEntities: [],
        webPageProperties: {},
        website,
        location,
    });
};

export default prepareHomePageStructuredPageData;
